import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@algoan/dashboard/store/store';
import { ActivityEntryByDate, Pagination, AsyncStatus, CashFlow, GroupedCashFlow } from '@algoan/dashboard/model';
import { isAccountsLoadingSelector } from './account-selectors';
import { isTransactionsLoadingSelector } from './transaction-selectors';

export const activityLoadingSelector: (state: RootState) => boolean = createSelector(
  (state: RootState): AsyncStatus => state.activity.activityListFetchingStatus,
  (activityListFetchingStatus): boolean =>
    activityListFetchingStatus === AsyncStatus.IDLE || activityListFetchingStatus === AsyncStatus.PENDING,
);

export const activityGroupedByDateSelector = (state: RootState): ActivityEntryByDate[] =>
  state.activity.activityEntryListGroupedByDate;

export const activityPaginationSelector = (state: RootState): Pagination => state.activity.pagination;

export const activityCashFlowSelector = (state: RootState): GroupedCashFlow | CashFlow | undefined =>
  state.activity.activityCashFlow;

export const activityCashFlowLoadingSelector: (state: RootState) => boolean = createSelector(
  (state: RootState): AsyncStatus => state.activity.activityCashFlowFetchingStatus,
  (activityCashFlowFetchingStatus): boolean =>
    activityCashFlowFetchingStatus === AsyncStatus.IDLE || activityCashFlowFetchingStatus === AsyncStatus.PENDING,
);

export const activityModalLoadingSelector: (state: RootState) => boolean = createSelector(
  //The input selectors are defined this way here to avoid causing a circular dependency issue as explained here https://github.com/reduxjs/reselect/issues/169#issuecomment-246212998
  (state: RootState) => isAccountsLoadingSelector(state),
  (state: RootState) => isTransactionsLoadingSelector(state),
  (state: RootState) => activityCashFlowLoadingSelector(state),
  (accountFetchingStatus, transactionFetchingStatus, activityCashFlowFetchingStatus): boolean =>
    accountFetchingStatus || transactionFetchingStatus || activityCashFlowFetchingStatus,
);
export const activityCustomerIdSelector = (state: RootState): string | undefined =>
  state.activity.activityCashFlowCustomerId;

export const activityAnalysisIdSelector = (state: RootState): string | undefined =>
  state.activity.activityCashFlowAnalysisId;
